module.exports = __webpack_public_path__ + "static/img/3.6de8990.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/3.png
// module id = Ubx6
// module chunks = 0